import { lazy } from "react";
import { Box } from "@mui/material";
import img from "../../../assets/img/part1Goal/group.webp";
import { useNextStep, useWindowSize } from "../../../hooks";
import { TPage } from "../../../model";
import * as S from "./style";

const CustomHeader = lazy(() => import("../../../components/CustomHeader/CustomHeader"));
const CustomButton = lazy(() => import("../../../components/Base/CustomButton/CustomButton"));

const Part2Goal: React.FC<TPage> = ({ pageId, nextPagePath }) => {
  const handleContinue = useNextStep({ pageId, nextPagePath });
  const { height } = useWindowSize();

  return (
    <S.Main>
      <S.PageContent height={height}>
        <CustomHeader part={2} header="GOAL" />
        <S.Content>
          <S.ImageContent>
            <S.Image src={img} alt="" />
          </S.ImageContent>
          <S.ContentText>
            <Box padding="2rem">
              Understanding your body shape can help you identify your personal weak points. Body analysis results can guide you in which areas you need to make progress.
            </Box>
          </S.ContentText>
        </S.Content>
        <CustomButton width={height / 2} text="Continue" onClick={() => handleContinue()} />
      </S.PageContent>
    </S.Main>
  );
};

export default Part2Goal;
